import { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { selectIsAuthorized, selectIsAuthLoaded } from '../services/selectors';

const authorizableHOC = (Component, Firewall, Loader) => {
    const mapStateToProps = state => ({
        isAuthorized: selectIsAuthorized(state),
        isLoading: !selectIsAuthLoaded(state),
    });

    const Authorizable = ({ isAuthorized, isLoading, ...props }) => (
        <Fragment>
            {isLoading && <Loader />}
            {isAuthorized && <Component {...props} />}
            {!isAuthorized && !isLoading && <Firewall {...props} />}
        </Fragment>
    );

    Authorizable.propTypes = {
        isAuthorized: PropTypes.bool,
        isLoading: PropTypes.bool,
    };

    Authorizable.defaultProps = {
        isAuthorized: false,
        isLoading: false,
    };

    return connect(mapStateToProps)(Authorizable);
};

export default authorizableHOC;
